<template>
  <Transition>
    <ScrollPage :key="currentPage" class="default-page-anim" @next="next">
      <SAM :data="page.content" class="page-content-anim page-content-margin" />
    </ScrollPage>
  </Transition>
</template>

<script>
import ScrollPage from "@/components/pages/ScrollPage.vue";
import SAM from "@/components/content/SAM.vue";

import * as Background from "@/scripts/background.js";

export default {
  emits: ["next"],
  components: {
    ScrollPage,
    SAM,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 0,
      page: this.data[0],
      lastPage: this.data.length - 1,
    };
  },
  methods: {
    next() {
      if (this.currentPage === this.lastPage) {
        this.$emit("next");
      } else {
        this.page = this.data[++this.currentPage];
        Background.transitionDown();
      }
    },
  },
};
</script>
